import {
  SET_DATA,
  SET_UPLOAD_DATA,
  SET_MENU_DATA,
  SET_ACTIVE
} from './mutation-types.js'

// 给路由绑定埋点信息
const logData = {
  'project/joined': '100112002',
  'project/all': '100112001'
}

export default {
  [SET_DATA] (state, data) {
    state.user = data
  },
  [SET_UPLOAD_DATA] (state, data) {
    state.uploadhistory = data
  },
  [SET_MENU_DATA] (state, data) {
    let menu = []
    if (data) {
      menu = data.map((item) => {
        item.title = item.name
        item.icon = `w-icon-${item.icon}`
        if (item.childrenMenu) {
          item.children = item.childrenMenu.map((childItem) => {
            childItem.icon = `w-icon-${childItem.icon}`
            childItem.title = childItem.name
            childItem.path = childItem.routeName
            // 加上埋点数据
            if (!childItem.log && childItem.routeName) {
              childItem.log = logData[childItem.routeName]
            } else if (!childItem.log && childItem.linkUrl) {
              childItem.log = logData[childItem.linkUrl]
            }
            return childItem
          })
        }
        return item
      })
    }
    state.user = menu
    state.sidebarReady = true
  },
  [SET_ACTIVE] (state, data) {
    state.active = data
  }
}
